/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace RioERP.Enquiry {

    @Serenity.Decorators.registerClass()
    export class EnquiryFollowupEditor extends Common.GridEditorBase<EnquiryFollowupRow> {

        protected getColumnsKey() { return 'Enquiry.EnquiryFollowup'; }
        protected getDialogType() { return EnquiryFollowupEditDialog; }

        protected getLocalTextPrefix() { return EnquiryRow.localTextPrefix; }
        public maxMark: number;

        constructor(container: JQuery) {
            super(container);
        }
        public DisableAddButton() {
            this.toolbar.findButton('add-button').show();
        }
     
        protected getAddButtonCaption() {
            return "Add";
        }
        validateEntity(row: Enquiry.EnquiryFollowupRow, id: number) {
       
            
            //var sameProduct = Q.tryFirst(this.view.getItems(), x => x.InvoiceId == row.InvoiceId);

            //if (sameProduct && this.id(sameProduct) !== id) {
            //    Q.alert('This Invoice is already added!');
            //    return false;
            //}
            //row.PoId = Purchase.Po_HeadRow.getLookup().itemById[row.StudentTempDetail].PoId;
            return true;
        }

        protected initEntityDialog(itemType: string, dialog: Serenity.Widget<any>) {
            super.initEntityDialog(itemType, dialog);
            // passing discount from grid editor to detail dialog
            (dialog as EnquiryFollowupEditDialog).maxMark = this.maxMark;
        }
        //get selectedItems() {
        //    return this.rowSelection.getSelectedKeys().map(x => this.view.getItemById(x));
        //}



    }
}